import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type SendButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
};

const SendButton = ({
    label = "Send",
    loadingText = "Sending...",
    buttonType = "submit",
    ...props
}: SendButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="send"
            testId="send-button"
            buttonType={buttonType}
            {...props}
        />
    );
};

export default SendButton;
